import {Component, output, inject, input} from '@angular/core';
import {FormGroup, FormGroupDirective, ReactiveFormsModule} from "@angular/forms";
import {LowerCasePipe, NgTemplateOutlet} from "@angular/common";

@Component({
  selector: 'app-form-element',
  templateUrl: './form-element.component.html',
  imports: [
    ReactiveFormsModule,
    NgTemplateOutlet,
    LowerCasePipe,
  ],
  standalone: true,
  styleUrls: ['./form-element.component.scss']
})
export class FormElementComponent {
  private rootFormGroup = inject(FormGroupDirective);

  readonly name = input<string>('');
  readonly label = input<string>('');
  readonly placeholder = input<string>('');
  readonly id = input<string>('');
  readonly type = input<string>('');
  readonly isReadonly = input<boolean>(false);
  readonly autocomplete = input<string>('none');
  readonly emptyOptionLabel = input<string | null>('Избери');
  readonly selectValueOptions = input<Map<string, string>>(new Map());
  readonly helperText = input<string | null>(null);

  keyUpOutput = output<any>();
  changeOutput = output<any>();

  form!: FormGroup;

  ngOnInit(): void {
    this.form = this.rootFormGroup.control;
  }

  protected getId(): string {
    const id = this.id();
    if (id) {
      return id.toString();
    } else {
      return this.name().toString();
    }
  }

  getPlaceholder() {
    return this.placeholder() ? this.placeholder() : this.label();
  }

  onKeyup(event: any) {
    this.keyUpOutput.emit({
      "formElementName": this.name(),
    });
  }

  onChange(event: any) {
    this.changeOutput.emit({
      "formElementName": this.name(),
      "formElementValue": event.target.value,
    });
  }
}
